// extracted by mini-css-extract-plugin
export default {"container":"TableThreeFooter_container__r3NwE"};